package ru.villawonka.app.data.entity.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import ru.villawonka.app.data.entity.dto.AccommodationTypeDto
import ru.villawonka.app.data.entity.dto.SortTypeDto
import ru.villawonka.app.data.entity.dto.toDto
import ru.villawonka.app.data.entity.dto.toDtoString
import ru.villawonka.app.domain.model.SearchParamsDomain
import ru.villawonka.app.domain.model.SortTypeDomain

@Serializable
data class SearchAccommodationRequest(
    @SerialName("cost_min") val costMin: Int? = null,
    @SerialName("cost_max") val costMax: Int? = null,
    @SerialName("city") val city: String? = null,
    @SerialName("districts") val districts: List<String>? = null,
    @SerialName("sort_type") val sort: SortTypeDto,
    @SerialName("accommodation_types") val accommodationTypes: List<AccommodationTypeDto>? = null,
    @SerialName("bedrooms") val bedrooms: List<String>? = null,
    @SerialName("additions") val additions: List<String>? = null,
    @SerialName("page") val page: Int,
    @SerialName("page_size") val pageSize: Int,
)

fun SearchParamsDomain.toSearchAccommodationRequest(
    page: Int,
    pageSize: Int,
    sortType: SortTypeDomain
): SearchAccommodationRequest = when (this) {
    is SearchParamsDomain.RentalItem.Accommodation -> SearchAccommodationRequest(
        costMin = costMin,
        costMax = costMax,
        city = city,
        districts = districts
            .takeIf { it.isNotEmpty() },
        sort = sortType.toDto(),
        accommodationTypes = accommodationTypes
            .map { it.toDto() }
            .takeIf { it.isNotEmpty() },
        bedrooms = bedrooms
            .takeIf { it.isNotEmpty() },
        additions = additions
            .map { it.toDtoString() }
            .takeIf { it.isNotEmpty() },
        page = page,
        pageSize = pageSize,
    )
    else -> throw IllegalStateException()
}